"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";
import { trackMetaPageView } from "./metaPixelCore";

/**
 * 站内路由切换补发 Meta PageView（Next.js 客户端跳转不重新加载页面）。
 * 首次加载的 PageView 已由 base code 发送，这里跳过。
 */
export function MetaPixelPageView() {
  const pathname = usePathname();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    trackMetaPageView();
  }, [pathname]);

  return null;
}
